import * as defs from './baseClass';
import './mods/';

window.defs = defs;
